import React, { useState, useEffect, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import uri from '../../utils/uri';
import http from '../../utils/http';
import { useSelector, useDispatch } from 'react-redux';
import Form, { GroupItem, Label, SimpleItem, StringLengthRule } from 'devextreme-react/form';
import { updateSmsDialog } from '../../store/sms/smsReducer';
import notify from 'devextreme/ui/notify';

const Nuevo = ({ clientId }) => {

    const { open, id } = useSelector(store => store.sms);   

    clientId = id > 0 ? id :  clientId;

    let refForm = useRef();

    const dispatch = useDispatch();
    const [sending, setSending] = useState(false);
    const [message, setMessage] = useState({
        clientId ,
        clientName : '',
        phoneNumber : '',
        phoneNumbers : [],
        message : ''
    });      
    
    const onHiding = () => dispatch(updateSmsDialog({ id : 0, open : false }));

    const onValueChanged = (e) => {
        setMessage({...message, phoneNumber : e.value});
    }

    const SendSms = (e) => {

        let result = refForm.current.instance.validate();

        if (result.isValid) {
            setSending(true);
            http(uri.sms.insert).asPost(message)
            .then(resp => {
                refForm.current.instance.resetValues();
                notify(`Mensaje enviado correctamente al numero ${message.phoneNumber}`);
                setSending(false);
                onHiding();
            }).catch(err=>{
                notify(err,'error');
                setSending(false);
            });
        
        }

    }

    useEffect(() => {
       http(uri.clients.getById(clientId)).asGet().then(resp => 
        {
            if(resp){
                let numbers = [];

                if(resp.phoneNumber) numbers.push(resp.phoneNumber);
                if(resp.phoneNumberWork) numbers.push(resp.phoneNumberWork);
                if(resp.cellNumber) numbers.push(resp.cellNumber);

                setMessage({...message, clientId : clientId ,phoneNumbers : [...numbers], clientName: `${resp.name } ${resp.lastName}` });
            }
        })
    }, [id]);



    return (
        <div>
             <Popup
                width={500}
                height={350}
                title={`Nueva aviso sms`}
                visible={open}
                onHiding={onHiding}
                >                           
                <br/>              
                <Form formData={message} ref={refForm}>
                    <GroupItem cssClass="second-group">
                        <SimpleItem dataField="clientName"
                            editorOptions={{
                                disabled: true
                            }} >
                                <Label text="Cliente"/>
                        </SimpleItem>
                        <SimpleItem dataField="phoneNumber" editorType="dxSelectBox"
                            editorOptions={{                              
                                dataSource: [...message.phoneNumbers],                                 
                                onValueChanged: onValueChanged,
                            }} >
                                <Label text="Numero"/>
                        </SimpleItem>   
                        <SimpleItem dataField="message" editorType="dxTextArea"
                            editorOptions={{
                                height: 90
                            }} >                            
                            <Label text="Mensaje"/>
                            <StringLengthRule max={150} message="Maximo 150 caracteres" />
                        </SimpleItem>      
                    </GroupItem>                    
                </Form>
                <br/>
                <Button
                    width={120}
                    text= {sending ? "Enviando":"Enviar" }
                    type="default"
                    icon="fas fa-mobile-alt"
                    stylingMode="contained"
                    className="m-1"
                    disabled={sending}
                    onClick={SendSms}
                />
            </Popup>
        </div>
    );
}

export default Nuevo;
